import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { LazyRoute, ProtectedRoute } from "./LazyRoute";
import { LandingRedirect } from "./LandingRedirect";

const LoginPage = lazy(() => import("../pages/auth/LoginPage"));
const NotFound = lazy(() => import("../pages/NotFound"));
const DashboardPage = lazy(() => import("../pages/dashboard/page"));
const AppUpdatesPage = lazy(() => import("../pages/app-updates/page"));
const DevicesPage = lazy(() => import("../pages/devices/page"));
const PushPage = lazy(() => import("../pages/push/page"));
const PaymentMethodsPage = lazy(() => import("../pages/payment-methods/page"));
const FeatureFlagsPage = lazy(() => import("../pages/feature-flags/page"));
const BuyerServiceFaqPage = lazy(() => import("../pages/buyer-service-faq/page"));
const SupportTracesPage = lazy(() => import("../pages/support-traces/page"));
const AirbridgeLinksPage = lazy(() => import("../pages/airbridge-links/page"));
const TimelinePage = lazy(() => import("../pages/timeline/page"));
const SystemPage = lazy(() => import("../pages/system/page"));
const UsersPage = lazy(() => import("../pages/users/page"));
const AuditLogPage = lazy(() => import("../pages/audit-log/page"));

const routes: RouteObject[] = [
  {
    path: "/login",
    element: (
      <LazyRoute>
        <LoginPage />
      </LazyRoute>
    ),
  },
  { path: "/register", element: <Navigate to="/login" replace /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <LandingRedirect />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/app-updates",
    element: (
      <ProtectedRoute>
        <AppUpdatesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/devices",
    element: (
      <ProtectedRoute>
        <DevicesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/push",
    element: (
      <ProtectedRoute>
        <PushPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment-methods",
    element: (
      <ProtectedRoute>
        <PaymentMethodsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/feature-flags",
    element: (
      <ProtectedRoute>
        <FeatureFlagsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/buyer-service-faq",
    element: (
      <ProtectedRoute>
        <BuyerServiceFaqPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/support-traces",
    element: (
      <ProtectedRoute>
        <SupportTracesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/airbridge-links",
    element: (
      <ProtectedRoute>
        <AirbridgeLinksPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/timeline",
    element: (
      <ProtectedRoute>
        <TimelinePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/system",
    element: (
      <ProtectedRoute>
        <SystemPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute>
        <UsersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/audit-log",
    element: (
      <ProtectedRoute>
        <AuditLogPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: (
      <LazyRoute>
        <NotFound />
      </LazyRoute>
    ),
  },
];

export default routes;
